import { SECTIONS } from "../../constants/sections.jsx";

export function SidebarTooltipPortal({ hoveredTip, tipRect, hoveredSec, dark, isCollapsed }) {
  if (!hoveredTip || !tipRect || hoveredSec) return null;
  const gap = 8;
  const style = {
    position: "fixed",
    zIndex: 9999,
    background: dark ? "#1A1C22" : "#18160E",
    color: "#fff",
    fontSize: 11,
    fontWeight: 500,
    padding: "5px 10px",
    borderRadius: 6,
    whiteSpace: "nowrap",
    pointerEvents: "none",
    boxShadow: "0 2px 8px rgba(0,0,0,.3)",
    animation: "tooltip-in .12s ease",
  };
  const tipMap = {
    "collapse-btn": isCollapsed ? "Expand sidebar" : "Collapse sidebar",
    "theme-btn": dark ? "Light mode" : "Dark mode",
    "bell-btn": "Notifications",
    "accent-btn": "Accent color",
    ...Object.fromEntries(SECTIONS.map((s) => [`sec-${s.id}`, s.label])),
  };
  const label = tipMap[hoveredTip] || hoveredTip;
  const side = hoveredTip.startsWith("sec-") ? "right" : "top";
  if (side === "right") {
    style.left = tipRect.right + gap;
    style.top = tipRect.top + tipRect.height / 2;
    style.transform = "translateY(-50%)";
  } else {
    style.left = tipRect.left + tipRect.width / 2;
    style.bottom = window.innerHeight - tipRect.top + gap;
    style.transform = "translateX(-50%)";
  }
  return <div style={style}>{label}</div>;
}
